// utils/logger.js

/**
 * Logger centralizado para la aplicación
 * - En desarrollo: muestra todos los logs
 * - En producción: solo muestra errores y warnings
 * 
 * Uso:
 * import logger from '../utils/logger';
 * logger.debug('mensaje de debug');
 * logger.info('información');
 * logger.warn('advertencia');
 * logger.error('error', errorObject);
 */

const isDevelopment = process.env.NODE_ENV === 'development';

const logger = {
  /**
   * Debug - solo en desarrollo
   */
  debug: (...args) => {
    // Logs disabled
  },

  /**
   * Info - solo en desarrollo
   */
  info: (...args) => {
    if (isDevelopment) {
      console.info('[INFO]', ...args);
    }
  },

  /**
   * Warning - siempre visible
   */
  warn: (...args) => {
    console.warn('[WARN]', ...args);
  },

  /**
   * Error - siempre visible
   */
  error: (...args) => {
    console.error('[ERROR]', ...args);
  },

  /**
   * Log de API requests - solo en desarrollo
   */
  api: (method, url, status) => {
    if (isDevelopment) {
      const emoji = status >= 200 && status < 300 ? '✅' : '❌';
      // HTTP log disabled
    }
  },

  /**
   * Log de tiempo de ejecución - solo en desarrollo
   */
  time: (label) => {
    if (isDevelopment) {
      console.time(label);
    }
  },

  timeEnd: (label) => {
    if (isDevelopment) {
      console.timeEnd(label);
    }
  }
};

export default logger;
